import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs
import { Observable } from 'rxjs';

// Commons
import { getHttpHeaders } from '@commons/utility/util';

// Models
import { ClearanceLetterResponseType } from '@model/historicResponse';

// Environments
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DetailCreditService {
  private clearanceLetterUrl = environment.apiGatewayUrl;
  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public buildClearanceLetterCertificate(loanCode: number, token: string): Observable<ClearanceLetterResponseType> {
    this.headers.append('Authorization', token);
    return this.http.get<ClearanceLetterResponseType>(
      this.clearanceLetterUrl + 'credit-management/back-loaninformation/private/credit/clearance-letter/' + loanCode,
      {
        headers: this.headers,
        responseType: 'json',
      }
    );
  }
}
